import * as z from "zod";
import { marketingAttributionSchema } from "./completeProfile";
import { mutator } from "./mutator";

export const recordPostSignupFormViewSchema = z.object({
  marketingAttribution: marketingAttributionSchema.optional(),
});

// Writes nothing: the server mutator posts to the HQ lead pipeline after the
// transaction commits.
export const recordPostSignupFormView = mutator({
  stripKeys: {
    marketingAttribution: Object.keys(marketingAttributionSchema.shape),
  },
  schema: recordPostSignupFormViewSchema,
  resolve: {},
  permissions: {
    none: "records that the caller was shown their own post-signup form",
  },
  fn: async () => {},
});
